import { render, staticRenderFns } from "./MonitorV2TotalCountCard.vue?vue&type=template&id=28ba6edc&scoped=true&lang=pug&"
import script from "./MonitorV2TotalCountCard.vue?vue&type=script&lang=js&"
export * from "./MonitorV2TotalCountCard.vue?vue&type=script&lang=js&"
import style0 from "./MonitorV2TotalCountCard.vue?vue&type=style&index=0&id=28ba6edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ba6edc",
  null
  
)

export default component.exports